import axios from 'axios'
// import router from '../router'
import {apiURL} from "./config";

const onUnauthorized = () => {
    // router.push({path: "/auth", query: {logout: true}});
};

const RESULTCODE = {
    INVALIDE_PARAMETER: "INVALID_PARAMETER",
    SUCCEEDED: "SUCCEEDED",
    ERROR: "ERROR"
}
export const setAuthInHeader = token => {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
};

export const request = {
    get(path, params=null) {
        return axios.get(`${apiURL + path}`, {params: params})
            .then(res => {
                // if(res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) return alert("문제가 발생했습니다. 다시 시도해주세요.");
              if(res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                alert("문제가 발생했습니다. 다시 시도해주세요.");
                // router.push('/auth')
                // window.location.reload(true)
                  return res;
                }
              else return res;
            }).catch(({response}) => {
                // router.push('/auth')
                const {status} = response;
                if (status === 400 || status === 401 || status === 500){
                    return onUnauthorized();
                }else if(status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    post(path, data) {
        return axios.post(`${apiURL + path}`, data)
            .then(res => {
                // if(res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) return alert("문제가 발생했습니다. 다시 시도해주세요.");

                if(res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    // router.push('/auth')
                    // window.location.reload(true)
                  return res;
                }
                else return res;
            })
            .catch(({response}) => {
                // router.push('/auth')
                const {status} = response;
                if (status === 400 || status === 401 || status === 500){
                    return onUnauthorized();
                }else if(status === Errored){
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    recordPost(path, data) {
        // let url = 'https://86zhm7ht62.execute-api.ap-northeast-2.amazonaws.com/v1/record'
        let url = 'https://janusapi.koreanssam.com/'
        let config = {
            // withCredentials: true,
            headers: {
                "Content-Type": `application/json`,
                // "Access-Control-Allow-Origin": "*",
                "Authorization": "",
                // "Accept": "*/*"
            },
        }
        return axios.post(`${url + path}`, JSON.stringify(data), config).then(res => {
            // return axios.post(`${url + path}`, data).then(res => {
            if(res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                alert("문제가 발생했습니다. 다시 시도해주세요.");
                return res;
            }
            else return res;
        }).catch(({response}) => {
            const {status} = response;
            if (status === 400 || status === 401 || status === 500){
                return onUnauthorized();
            }else if(status === Errored){
                alert("잘못된 정보입니다.")
            }
            throw Error(response)
        })
    },

};
